var trackingEvent = require('src/interlock/no-ui/tracking/event');
var constant = require('src/interlock/no-ui/tracking/constant');

var toolMap = require('./tool'),
    navMap = require('./nav');

var map = {

    provide_zip_code: trackingEvent.actionCompleted(
        constant.ACTION_PROVIDE_ZIP_CODE, constant.ACTION_PROVIDE_ZIP_CODE),

    view_search_result: trackingEvent.actionCompleted(
        constant.VIEW_SEARCH_RESULT, constant.VIEW_SEARCH_RESULT),

    view_content: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.ACTION_VIEW_CONTENT),

    view_content_search_result: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_SEARCH_RESULT),

    view_content_summary: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_CONTENT, constant.VIEW_SUMMARY),

    view_pricing_details: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_PRICING_DETAILS, constant.VIEW_PRICING_DETAILS),

    view_edmunds_review: trackingEvent.actionCompleted(
        constant.ACTION_VIEW_REVIEW, constant.VIEW_EDMUNDS_REVIEW),

    mmy_select_submit: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MMY),

    mmy_select_submit_make: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    mmy_select_submit_model: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MODEL),

    seo_footer_mmy_submit_make: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MAKE),

    seo_footer_mmy_submit_model: trackingEvent.actionEnd(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MODEL),

    seo_footer_mmy_submit: trackingEvent.actionCompleted(
        constant.ACTION_MMY_SELECT, constant.SUBMIT_MMY)
};

// For unit testing purposes
module.exports = $.extend({}, toolMap, navMap, map);



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/tracking/maps/common/index.js
// module id = 82
// module chunks = 0 1 2 3 4 5 6 7 8 9 11 12 13 14